import UserInviteController from './userInviteController';
import './userInvite.scss';

const UserInviteComponent = {
    template: require('./userInviteView.html'),
    controller: UserInviteController,
    bindings: {
        onSuccess: '&'
    },
};

export default UserInviteComponent;




// WEBPACK FOOTER //
// ./src/app/pages/user/list/invite/userInviteComponent.js